export default {
  state: {
    faq: { title: "", body: "" },
    faqModal: {},
    selectedFaq: {},

    helpModalStatus: false,
  },

  getters: {
    getFaq(state) {
      return state.faq;
    },

    getFaqModal(state) {
      return state.faqModal;
    },

    getSelectedFaq(state) {
      return state.selectedFaq;
    },

    //
    getHelpModalStatus: (state) => state.helpModalStatus,
  },

  mutations: {
    setFaq(state, data) {
      state.faq = data;
    },

    setFaqModal(state, data) {
      state.faqModal = data;
    },

    setSelectedFaq(state, data) {
      state.selectedFaq = data;
    },

    setHelpModalStatus(state, status) {
      state.helpModalStatus = status;
    },
  },

  actions: {
    changeFaq(context, data) {
      context.commit("setFaq", data);
    },

    changeFaqModal(context, data) {
      context.commit("setFaqModal", data);
    },

    changeSelectedFaq(context, data) {
      context.commit("setSelectedFaq", data);
    },

    changeHelpModalStatus(context, status) {
      context.commit("setHelpModalStatus", status);
    },
  },
};
